import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=48fd7e41&scoped=true&"
var script = {}
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=48fd7e41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd7e41",
  null
  
)

export default component.exports